// import '@babel/polyfill'
// import 'babel-polyfill'
import Es6Promise from 'es6-promise'
Es6Promise.polyfill()
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import GlobalComponents from "@/components";
import '@/plugins/vant.js'
import "@/assets/style/common.less"; // 初始化CSS
// import 'vue-video-player/src/custom-theme.css'
// import 'video.js/dist/video-js.css'
import Vconsole from "vconsole";
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import "./permission.js"
Vue.prototype.$store = store
Vue.config.productionTip = false;
Vue.use(GlobalComponents);
if (process.env.NODE_ENV !== "production") {
  const vConsole = new Vconsole();
  Vue.use(vConsole);
}
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
